module.exports = __webpack_public_path__ + "img/gmt.c9d12cc9.svg";